
export default {
    slug: 'guestlists/shifts',
    title: 'Guestlist shifts',
    visible: [
        'title'
    ],
    listview: 'GuestlistShiftListView',
    locales: ['common'],
    columns: [
        {
            key: 'title',
            main: true
        }
    ],
}


// WEBPACK FOOTER //
// ./src/app/store/guestlists/shifts/state.js